module.exports = __webpack_public_path__ + "static/media/devices-icon.ff492de8.svg";